module.exports = __webpack_public_path__ + "static/media/18ECA36.9a4fd1b3.jpg";